module.exports = __webpack_public_path__ + "static/media/favicon_nakire.ead05623.png";